// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"457":"64978cd6","495":"171c599e","540":"827ac27a","931":"3c496385","962":"8f2e4da4"}[chunkId] + ".chunk.css";
};